import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.242 15A4.5 4.5 0 1 0 6.5 17h11a4.5 4.5 0 1 0-3.742-2zM6.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m11 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
      clipRule: "evenodd"
    }
  )
);
var SvgVoicemailOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VoicemailOutlined_default = SvgVoicemailOutlined;

export { VoicemailOutlined_default as default };
